<template>
  <v-container fluid class="home-page fill-height pa-0">
    <v-row class="fill-height">
        <HomePageChapter :direction="direction" :index="chapterIndex" :data="chapters" />
        <p class="ml-6 ml-md-12 mb-0 pb-2 projects-num">{{chapterIndex}}
          <span class="strip"
            :style="{'width': (20 + ((chapterIndex / chapters.length) * (viewPort.width / 4))) +'px'}"></span> {{chapters.length-1}}</p>
    </v-row>

    <NextPrevChapterSidebar
      :bg="nextBg"
      @next:click="onNextChapterClick"
      @prev:click="onPrevChapterClick"
    />
  </v-container>
</template>

<script>
import NextPrevChapterSidebar from '@/atoms/NextPrevChapterSidebar'
import HomePageChapter from '@/organisms/HomePageChapter'
import { Viewport } from '@monogrid/vue-lib'

export default {
  name: 'Home',

  mixins: [Viewport],

  components: {
    NextPrevChapterSidebar,
    HomePageChapter
  },

  data () {
    return {
      chapterIndex: 0,
      direction: 'next',
      chapters: this.$root.chapters
    }
  },

  computed: {
    nextBg () {
      const nextChapter = (this.chapterIndex + 1) >= this.chapters.length ? 0 : this.chapterIndex + 1
      return this.chapters[nextChapter].comingSoon ? '' : this.chapters[nextChapter].heroImage.id
    }
  },

  methods: {
    onNextChapterClick () {
      this.direction = 'next'

      if (this.chapterIndex === this.chapters.length - 1) {
        this.chapterIndex = 0
      } else {
        this.chapterIndex += 1
      }
    },

    onPrevChapterClick () {
      this.direction = 'prev'

      if (this.chapterIndex === 0) {
        this.chapterIndex = this.chapters.length - 1
      } else {
        this.chapterIndex -= 1
      }
    }
  },

  metaInfo: function () {
    return {
      // home page browser title
      title: this.$gettext('Home Page')
    }
  }
}
</script>

<style scoped lang="scss">

.home-page-fixed-bottom {
  position: absolute;

  bottom: 0;
  left: 0;

  width: 100%;
  z-index: 3;

  &::before {
    content: '';
    display: table;

    border-top: 1px solid $c-text-grey;

    width: 100%;
    height: 100%;
  }
}

.projects-num {
  position: absolute;
  width: 85%;
  text-align: right;
  border-bottom: 1px solid $c-grey;

  bottom: 12px;

  @include breakpoint('sm-and-down') {
    width: 70%;
  }

  .strip {
    height: 1px;
    display: inline-block;
    background-color: $c-grey;
    vertical-align: middle;
    line-height: 16px;
    transition: width 0.5s;
    margin-bottom: 2px;
  }
}

.bottom-copy {
  font-family: Barlow;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: left;
  text-transform: uppercase;
}
</style>
